<template>
  <div class="cloud">
    <!-- <a-spin :spinning="spinning" size="large"> -->
       <a-tabs type="card" :activeKey="activeKey" @change="changeTab" >
        <a-tab-pane tab="AI人岗匹配" key="1" :forceRender="true"></a-tab-pane>
        <a-tab-pane tab="职位画像匹配" key="2" :forceRender="true">
          <a-form class="draw-form" :form="form" @submit="handleSubmit" layout="inline">
            <a-form-item class="form-item" label="工作年限:">
              <a-select
                style="width:150px;"
                placeholder="请选择工作年限"
                v-decorator="[ 'experience_id' ]"
              >
                <a-select-option :value="item.value" v-for="item in workExperienceData" :key="item.value" :text="item.label">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item class="form-item" label="学历要求:">
              <a-select
                style="width:120px;"
                placeholder="请选择学历"
                v-decorator="[ 'education_id' ]"
              >
                <a-select-option :value="item.value" v-for="item in educationData" :key="item.value" :text="item.label">{{ item.label }}</a-select-option>
              </a-select>&nbsp;&nbsp;及以上
            </a-form-item>
            <a-form-item class="form-item" label="专业要求:">
              <a-input
                style="width:200px;margin-right: 5px;"
                placeholder="不限"
                allowClear
                v-decorator="['major_requirement']"
              />
            </a-form-item>
            <a-form-item class="form-item" label="行业要求:">
              <el-cascader
                class="industryCascader"
                v-model="job_industrys"
                style="width:360px;"
                placeholder="请选择行业"
                :options="jobIndustry"
                :props="{ multiple: true, label: 'name', value: 'id', children: 'children', expandTrigger: 'hover', }"
                clearable
                @change="changeIndustry"
              />
            </a-form-item><br/>
            <a-form-item class="form-item" label="技能要求:">
              <a-input
                v-decorator="['requirement_skill']"
                style="width:200px;"
                readonly
                @click="showTagsModal('requirement_skill')"
              ></a-input>
            </a-form-item>
            <a-form-item class="form-item" label="语言要求:">
              <a-checkbox-group v-decorator="['language_requirement']" style="width:440px;" >
                <a-checkbox value="英语">英语</a-checkbox>
                <a-checkbox value="普通话">普通话</a-checkbox>
                <a-checkbox value="粤语">粤语</a-checkbox>
                <a-checkbox value="日语">日语</a-checkbox>
                <a-checkbox value="法语">法语</a-checkbox>
                <a-checkbox value="其他">其他</a-checkbox>
              </a-checkbox-group>
            </a-form-item>
            <a-form-item class="form-item" label="不考虑出生地:">
              <a-cascader
                changeOnSelect
                style="width:200px;"
                :options="area"
                placeholder="请选择"
                :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
                v-decorator="[ 'inactive_born' ]"
              />
            </a-form-item>
            <a-form-item class="form-item" label="优先考虑学校类型:">
              <a-radio-group
                :options="[
                  { label: '普通高校', value: 0 },
                  { label: '211院校', value: 1 },
                  { label: '985院校', value: 2 },
                  { label: '985/211', value: 3 },
                  { label: '外国院校', value: 4 },
                  { label: '不限', value: '' },
                ]"
                v-decorator="[ `draw_portrait_active_tag.active_school_type`, ]"
              />
            </a-form-item>
            <a-form-item class="form-item" label="不考虑性别:">
              <a-radio-group
                :options='[{ label: "男", value: 1 }, { label: "女", value: 2 }, { label: "不限", value: 0 }]'
                v-decorator="[ `draw_portrait_inactive_tag.inactive_gender_id`, ]"
              />
            </a-form-item>
            <a-form-item class="form-item" label="不考虑婚姻状况:">
              <a-radio-group
                :options="[
                  { label: '已婚', value: 2 },
                  { label: '未婚', value: 1 },
                  { label: '已婚已孕', value: 3 },
                  { label: '不限', value: 0 },
                ]"
                v-decorator="[ `draw_portrait_inactive_tag.inactive_is_married`, ]"

              />
            </a-form-item>
            <a-form-item class="form-item" label="优先考虑婚姻状况:">
              <a-radio-group
                :options="[
                  { label: '未婚', value: 1 },
                  { label: '已婚', value: 2 },
                  { label: '不限', value: 0 },
                ]"
                v-decorator="[ `draw_portrait_active_tag.active_is_married`, ]"
              />
            </a-form-item>
            <a-form-item class="form-item" label="不考虑频繁跳槽:">
              <a-radio-group
                :options='[{ label: "5年2跳", value: 1 }, { label: "5年3跳", value: 2 }, { label: "不限", value: 0 } ]'
                v-decorator="[ `draw_portrait_inactive_tag.inactive_job_hopping_interval`, ]"
              />
            </a-form-item>
            <a-form-item class="form-item" label="优先考虑第一学历:">
              <a-radio-group
                :options="[{ label: '统招', value: 1 }, { label: '不限', value: 0 }]"
                v-decorator="[ `draw_portrait_active_tag.active_admission_type`, ]"
              />
            </a-form-item>
            <a-form-item class="form-item" label="优先考虑薪资:">
              <a-input
                style="width:100px;margin-right: 5px;"
                addonAfter="K"
                allowClear
                v-decorator="['draw_portrait_active_tag.active_salary_min']"
              />—
              <a-input
                style="width:100px;margin-left: 5px;"
                addonAfter="K"
                allowClear
                v-decorator="['draw_portrait_active_tag.active_salary_max']"
              />
            </a-form-item>
            <a-form-item class="form-item" label="优先考虑管理:">
              <a-input
                style="width:200px;margin-right: 5px;"
                placeholder="不限"
                addonAfter="人以上"
                allowClear
                v-decorator="['draw_portrait_active_tag.active_manage_people']"
              />
            </a-form-item>
            <a-form-item class="form-item" label="不考虑年龄:">
              <a-input
                style="width:100px;margin: 0 5px 0 1em;"
                addonAfter="岁"
                allowClear
                v-decorator="['draw_portrait_inactive_tag.inactive_age_min']"
              />—
              <a-input
                style="width:100px;margin-left:5px;"
                addonAfter="岁"
                allowClear
                v-decorator="['draw_portrait_inactive_tag.inactive_age_max']"
              />
            </a-form-item>
            <a-form-item class="form-item" label="优先考虑年龄:">
              <a-input addonAfter="岁" style="width:100px;margin-right: 5px;" allowClear v-decorator="['draw_portrait_active_tag.active_age_min']"/>—
              <a-input style="width:100px;margin-left: 5px;" addonAfter="岁" allowClear v-decorator="['draw_portrait_active_tag.active_age_max']"/>
            </a-form-item>
            <a-form-item class="form-item" label="不考虑专业:">
              <a-input
                style="width:200px;margin-left:1em;"
                placeholder="请填写专业"
                allowClear
                v-decorator="['draw_portrait_inactive_tag.inactive_major']"
              />
            </a-form-item>
            <a-form-item class="form-item" label="优先考虑专业:">
              <a-input
                style="width:200px;margin-right: 5px;"
                placeholder="请填写专业"
                allowClear
                v-decorator="['draw_portrait_active_tag.active_major']"
              />
            </a-form-item>
            <a-form-item class="form-item" label="优先考虑证书:">
              <a-input
                style="width:200px;margin-right: 5px;"
                placeholder="不限"
                allowClear
                v-decorator="['draw_portrait_active_tag.active_certificate']"
              />
            </a-form-item>
            <a-form-item class="form-item" label="目标搜寻公司:">
              <a-auto-complete
                placeholder="请填写公司名称"
                v-model="companyName"
                :dataSource="dataCompanyName"
                @search="changeCompanyName"
                style="width: 350px;font-size:14px;"
                @select="addCompanyData"
              />
            </a-form-item>
            <a-form-item class="form-item" label="目标公司产品:">
              <a-select
                mode="multiple"
                style="width: 350px;"
                placeholder="请选择目标公司产品"
                @change="selectProduct"
                v-decorator="['direction_companys']"
              >
                <a-select-option v-for="item in dataProducts" :key="item.product_name" :product="item">
                  {{ item.product_name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <br/>
            <!-- 排序 -->
            <a-row type="flex" align="middle" justify="space-between">
              <a-col>
                <a-form-item style="margin-top: 5px;">
                  <a-button type="primary" html-type="submit">更新职位候选人画像</a-button>
                  <a-button type="default" @click="clear" style="margin-left:10px;">清空职位画像信息</a-button>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-tab-pane>
      </a-tabs>
      <a-input-search
        size="large"
        allow-clear
        placeholder="请输入关键词进行搜索"
        v-model="searchText"
        @search="search"
        style="margin-bottom:20px;"
      >
        <a-button type="primary" slot="enterButton">搜索</a-button>
      </a-input-search>
      <a-radio-group
        class="tabs"
        v-model="status"
        @change="handleTabChange"
      >
        <a-radio-button value="0">
          待处理简历（{{ cvInfo.pending_total }}）
        </a-radio-button>
        <a-radio-button value="2">
          已做单简历（{{ cvInfo.post_total }}）
        </a-radio-button>
        <a-radio-button value="1">
          已拒绝简历（{{ cvInfo.reject_total }}）
        </a-radio-button>
      </a-radio-group>

      <a-table
        class="table"
        style="margin-top: 20px;"
        rowKey="id"
        :columns="columns"
        :dataSource="listData"
        :pagination="pagination"
        :loading="spinning"
        @change="getResumeList"
        :scroll="{ x: 1600, y: 900 }"
      >
        <template slot="gender_id" slot-scope="gender_id">
          <span>{{ gender_id == 1 ? '男' : gender_id == 2 ? '女' : '不详' }}</span>
        </template>
        <template slot="salary_max" slot-scope="salary_max">
          <span>{{ salary_max ? salary_max + 'K' : '' }}</span>
        </template>
        <template slot="resume_match_degree" slot-scope="resume_match_degree">
          <span style="color:red;">{{ resume_match_degree + "%" }}</span>
        </template>
        <template  slot="authorized_status" slot-scope="text,record">
          <div v-if="record.authorized_status == 1">
            <span style="color:red">已拒绝</span>
            <div>
              <span>拒绝理由：{{ record.elimination_item.body && JSON.parse(record.elimination_item.body).reason_text.join(',') }}</span>
              <p>{{ record.elimination_item.body && JSON.parse(record.elimination_item.body).reason }}</p>
            </div>
          </div>
          <div v-else>
            <span style="color:green;">{{ record.authorized_status == 0 ? '待处理' : '已做单'}}</span>
            <div v-if="record.authorized_status == 2">
              订单编号：<a @click.prevent="$router.push('/order/detail/' + record.post_id)">{{ record.order_no }}</a >
            </div>
          </div>
        </template>
        <template slot="action" slot-scope="text,record">
          <template v-show="record.authorized_status == 0 && activeKey == '2'">
            <div>
              <a-button type="link" @click.stop="suitable(record)" :disabled="jobStatus==='PAUSED'">不合适</a-button>
            </div>
            <div>
              <a-button type="link" @click.stop="recommend(record)" :disabled="jobStatus==='PAUSED'">推荐职位</a-button>
            </div>
          </template>
          <div>
            <a-button type="link" icon="eye" @click.stop="previewResume(record)">查看简历附件</a-button>
          </div>
        </template>
      </a-table>
    <!-- </a-spin> -->
    <Recommend ref="recommend"></Recommend>
    <Suitable
      ref="suitableModal"
      :authorized_id="authorized_id"
      :getResumeList="getResumeList"
    ></Suitable>
    <a-drawer :visible="preview" :width="850" @close="preview = !preview">
      <img :src="preview_url" v-if="preview_url" />
      <a-empty v-if="previewEmpty" style="margin: 300px auto;">
        <span slot="description">暂无预览</span>
      </a-empty>
      <div class="drawer-btn" v-if="previewItem && previewItem.authorized_status == 0 ">
        <a-button
          type="primary"
          style="margin-right:20px"
          @click.stop="recommend(previewItem)"
          :disabled="jobStatus==='PAUSED'"
        >推荐做单</a-button>
        <a-button
          @click.stop="suitable(previewItem)"
          type="danger"
          :disabled="jobStatus==='PAUSED'"
          >简历不合适</a-button>
      </div>
    </a-drawer>

    <TagsModal ref="tagsModal" :tagList="skillsTag"  @ok="updateSkills"></TagsModal>

  </div>
</template>

<script>
// import * as Cookie from "@/shared/utils/auth";
// import { mapMutations } from "vuex";
import Pagination from "./Pagination";
import Recommend from "@/components/recomend";
import Suitable from "./suitable";
import Api from "@/api";
import TagsModal from "@/app/admin/post/tags-modal";
import debounce from "lodash/debounce";

export default {
  name: "cloud",
  props: ["id", "jobname", "jobid", "authStatus", "jobStatus", "jobDetail"],
  data() {
    const columns = [
      {
        title: "姓名",
        width: 80,
        dataIndex: "name"
      },
      {
        title: "性别",
        width: 80,
        dataIndex: "gender_id",
        sorter: true,
        sorterBy: {
          ascend: 'resume_gender_id_asc',
          descend: 'resume_gender_id_desc'
        },
        scopedSlots: { customRender: "gender_id" }
      },
      {
        title: "学历",
        width: 100,
        dataIndex: "education_name",
        sorter: true,
        sorterBy: {
          ascend: 'resume_education_id_asc',
          descend: 'resume_education_id_desc'
        },
      },
      {
        title: "工作经验",
        width: 110,
        align: "center",
        dataIndex: "working_years_name",
        sorter: true,
        sorterBy: {
          ascend: 'resume_experience_id_asc',
          descend: 'resume_experience_id_desc'
        },

      },
      {
        title: "期望城市",
        align: "center",
        width: 90,
        dataIndex: "expect_job.city_name"
      },
      {
        title: "期望薪酬",
        dataIndex: "expect_job.salary_max",
        align: "center",
        width: 110,
        sorter: true,
        sorterBy: {
          ascend: 'resume_expect_job_salary_asc',
          descend: 'resume_expect_job_salary_desc'
        },
        scopedSlots: { customRender: "salary_max" }
      },
      {
        title: "所在公司",
        dataIndex: "last_company"
      },
      {
        title: "匹配度",
        width: 100,
        dataIndex: "resume_match_degree",
        align: "center",
        sorter: true,
        sorterBy: {
          ascend: 'resume_match_degree_asc',
          descend: 'resume_match_degree_desc'
        },
        scopedSlots: { customRender: "resume_match_degree" }
      },
      {
        title: "联系方式",
        width: 120,
        align: "center",
        dataIndex: "mobile"
      },
      {
        title: "授权信息",
        colSpan: 2,
        dataIndex: "user.name",
        align: "center",
        width: 80,
        sorter: true,
        sorterBy: {
          ascend: 'resume_auth_created_asc',
          descend: 'resume_auth_created_desc'
        },
      },
      {
        title: "授权时间",
        dataIndex: "authorized_at",
        colSpan: 0,
      },
      {
        title: "简历状态",
        width: 250,
        dataIndex: "authorized_status",
        scopedSlots: { customRender: "authorized_status" },
      },
      {
        title: "操作",
        key: "action",
        align: "center",
        fixed: 'right',
        width: 170,
        scopedSlots: { customRender: "action" }
      }
    ];
    this.changeCompanyName = debounce(this.changeCompanyName, 800)
    return {
      columns,
      order: '', //筛选
      form: this.$form.createForm(this),
      activeKey: '1',
      searchText: "",
      status: "0",
      listData: [],
      cvInfo: {},
      spinning: false,
      showMask: false,
      loadMoreStatus: false,
      pages: 1,
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true
      },
      total: 0,
      visible: false,
      resumeId: undefined,
      modal: false,
      name: undefined,
      authorized_at: undefined,
      authorized_id: undefined,
      preview: false,
      preview_url: "",
      previewItem: undefined,
      educationData: [
        { label: "不限", value: "0" },
        { label: "博士", value: "1" },
        { label: "MBA/EMBA", value: "2" },
        { label: "硕士", value: "3" },
        { label: "本科", value: "4" },
        { label: "大专", value: "5" },
        { label: "高中/中专", value: "6" }
      ],
      workExperienceData: [
        { label: "不限", value: "0" },
        { label: "1年以下", value: "1" },
        { label: "1-3年", value: "2" },
        { label: "3-5年", value: "3" },
        { label: "5-10年", value: "4" },
        { label: "10-15年", value: "5" },
        { label: "15年以上", value: "6" }
      ],
      job_industrys: [],
      jobIndustry: [],
      area: [{ name: "全国", id: 0 }],
      tags: [],
      selectedTags: [], //选中
      skillsTag: [],
      companyName: '',
      dataCompanyName: [],
      dataProducts: [],
      products: [],
      previewEmpty: false,

    };
  },
  components: { Recommend, Pagination, Suitable, TagsModal },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.loadTreeData('getCityTree');
    this.loadTreeData('getIndustryTree');
  },
  mounted() {
    this.status = this.authStatus || "0";
    this.getResumeList();
    this.$nextTick( () => {
      this.pushForm();
    });
  },
  computed: {
    haveMore() {
      let more = this.total - this.pages * 10;
      return more > 0;
    }
  },
  methods: {
    changeCompanyName(value) {
      if (value.length >= 2) {
        Api.common.getCompanyList({ keyword: value }).then(res => {
          const data = [];
          res.list.forEach(item => {
            data.push(item.name);
          });
          this.dataCompanyName = data;
        });
      } else {
        this.dataCompanyName = [];
      }
    },
    addCompanyData(value, options) {
      this.companyName = value;
      Api.common.searchProducts({ keyword: value }).then(res => {
        this.dataProducts = res.list;
      });
    },
    selectProduct(value, opt) {
      this.products = [];
      opt.forEach( x => {
        this.products.push( x .data.attrs.product);
      })
      console.log(this.products);
    },
    async loadTreeData(type) {
      let response;
      try {
        response = await Api.common[type]();
      } catch (e) {
        e.message.cached && (response = e.message.data);
      }
      if(type == 'getCityTree') {
        this.area = [...this.area, ...response.tree];
      } else if( type == 'getIndustryTree') {
        this.jobIndustry = [...response.tree];
      }
    },
    clear() {
      this.form.resetFields();
      this.job_industrys = [];
      this.companyName = '';
    },
    changeIndustry(val) {
      if(val.length > 5) {
        this.$message.warning('行业类型最多选五个！');
        // this.job_industrys = [];
        this.job_industrys = this.job_industrys.slice(0, 5);
      }
      console.log(val);
    },
    pushForm() {
      console.log(this.jobDetail);
      let data = this.jobDetail;
      // 行业
      this.job_industrys = [];
      data.job_industrys && data.job_industrys.forEach( item => {
        let arr = [
          item.first_industry_id,
          item.second_industry_id,
          item.third_industry_id,
          item.fourth_industry_id,
        ]
        if(item.fourth_industry_id == 0) arr.length = 3;
        this.job_industrys.push(arr);
      })
      console.log(JSON.parse(data.language_requirement), 'data.language_requirement');
      let values = {
        experience_id: data.experience_id,
        education_id: data.education_id,
        major_requirement: data.major_requirement, //专业要求
        requirement_skill: data.requirement_skill, //技能要求
        inactive_born: [],
        language_requirement: data.language_requirement && JSON.parse(data.language_requirement) || [], //语言要求
        draw_portrait_active_tag: data.draw_portrait_active_tag ? JSON.parse(data.draw_portrait_active_tag) : undefined,
        draw_portrait_inactive_tag: data.draw_portrait_inactive_tag ? JSON.parse(data.draw_portrait_inactive_tag) : undefined,
      }
      values.inactive_born[0] = data.draw_portrait_inactive_tag.inactive_born_province_id || null; //所在地
      values.inactive_born[1] = data.draw_portrait_inactive_tag.inactive_born_city_id || null; //所在地
      values.inactive_born[2] = data.draw_portrait_inactive_tag.inactive_born_dist_id || null; //所在地

      console.log(values, 'values');
      delete values.inactive_born;

      this.form.setFieldsValue(values);
    },
    changeTab(key) {
      if(this.activeKey === key) {
        return false;
      }
      this.activeKey = key;
      if(this.activeKey === '2') {
        this.search();
      } else {
        this.getResumeList();
      }
    },
    handleParams() {
      let values = this.form.getFieldsValue();
      // 出生地
      values.draw_portrait_inactive_tag.inactive_born_province_id = values.inactive_born && values.inactive_born[0];
      values.draw_portrait_inactive_tag.inactive_born_city_id = values.inactive_born && values.inactive_born[1];
      values.draw_portrait_inactive_tag.inactive_born_dist_id = values.inactive_born && values.inactive_born[2];

        //行业
      values.job_industrys = [];
      this.job_industrys.forEach( item => {
        values.job_industrys.push({
          first_industry_id: item[0],
          second_industry_id: item[1],
          third_industry_id: item[2],
          fourth_industry_id: item[3]
        })
      });

      // 处理画像出生地
      values.draw_portrait_inactive_tag.inactive_born_province_id = values.inactive_born && values.inactive_born[0];
      values.draw_portrait_inactive_tag.inactive_born_city_id = values.inactive_born && values.inactive_born[1];
      values.draw_portrait_inactive_tag.inactive_born_dist_id = values.inactive_born && values.inactive_born[2];

      values.job_industrys = JSON.stringify(values.job_industrys);
      values.language_requirement = JSON.stringify(values.language_requirement);

      //目标公司 目标产品
      let direction_companys = [];

      direction_companys.push({
        company_name: this.companyName,
        products: this.products
      });
      values.direction_companys = JSON.stringify(direction_companys);
      delete values.inactive_born;
      console.log(values);
      return values;
    },
    search() {
      this.pagination.current = 1;
      let values = this.handleParams();
      let params = {
        ...values.draw_portrait_active_tag,
        ...values.draw_portrait_inactive_tag,
        education_id: values.education_id,
        experience_id: values.experience_id,
        major_requirement: values.major_requirement,
        requirement_skill: values.requirement_skill,
        language_requirement: values.language_requirement,
        direction_companys: values.direction_companys
      }
      this.getResumeList();
    },
    handleTabChange() {
      this.pagination.current = 1;
      this.getResumeList();
    },
    handleSubmit(e) {
      e.preventDefault();
      let that = this;
      this.$confirm({
        content: '更新候选人画像标签，将修改职位招聘要求和候选人画像，是否继续修改并保存？',
        onOk() {
          const values = that.handleParams();
          console.log(values, 'embeded-h5-api');
          let params = {
            job_id: that.id,
            body: JSON.stringify(values)
          }
          Api.position.updateJobDraw(params).then( res => {
            console.log(res);
          })
        }
      })

    },
    saveFormData() {
      let values = this.handleParams();
      let params = {
        ...values.draw_portrait_active_tag,
        ...values.draw_portrait_inactive_tag,
        education_id: values.education_id,
        experience_id: values.experience_id,
        major_requirement: values.major_requirement,
        requirement_skill: values.requirement_skill,
        language_requirement: values.language_requirement,
        direction_companys: values.direction_companys
      }
      return values;
    },
    async getResumeList(pagination, filters, sorter) {
      this.spinning = true;
      // if(drawParams && drawParams.currentDataSource ) delete drawParams.currentDataSource;
      let drawParams = this.saveFormData();
      let params = {
        page: this.pagination.current,
        limit: this.pagination.pageSize,
        key_word: this.searchText,
        auth_status: this.status,
      };
      if(sorter && sorter.order) {
        console.log(sorter.column.sorterBy[sorter.order]);
        params.order = sorter.column.sorterBy[sorter.order];
      } else {
        params.order = '';
      }
      if (pagination) {
        params.page = pagination.current;
        params.limit = pagination.pageSize;
        let pager = { ...this.pagination };
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      }
      let response;
      if(this.activeKey === '1') {
        // AI人岗
        params.job_id = this.id;
        response = await Api.position.getResumeAuthor(params);
      } else {
        params.auth_job_id = this.id;
        let newParams = Object.assign(params, drawParams);
        response = await Api.position.getAuthorizedJobDrawList(newParams);
      }
      this.spinning = false;
      if (response) {
        this.listData = response.list;
        this.cvInfo = response.header || {};
        this.pagination.total = +response.total;
      }
      this.spinning = false;

    },
    toggleJobView() {
      this.modal = !this.modal;
    },
    close() {
      this.modal = false;
    },
    suitable(item) {
      this.authorized_id = item.authorized_id;
      let { suitableModal } = this.$refs;
      suitableModal.show();
    },
    async recommend(resume) {
      let res = await Api.post.checkPost({
        resume_id: resume.id,
        job_id: this.jobid
      });
      if (res.result == 1) {
        this.resumeId = resume.id;
        let that = this;
        if (res.same_resume_name == 1) {
          this.$confirm({
          content: '系统检测到该职位已有猎头推荐同名候选人，疑似重复推荐！',
          okText: '继续推荐',
          cancelText: '取消',
          onOk() {
            that.$refs.recommend.show(resume, that.jobid, that.jobname);
          },
          onCancel() { return;},
          });
        }else{
          that.$refs.recommend.show(resume, that.jobid, that.jobname);
        }
      } else {
        this.$message.info("该手机号已被其他猎头简历投递，请更换其他简历");
      }
    },
    async previewResume(item) {
      this.previewItem = item;
      this.previewEmpty = false;
      this.preview = true;
      this.preview_url = '';
      let { attachments } = await Api.position.getAttachedResume({
        resume_id: item.id
      });
      if (attachments && attachments[0]) {
        let preview_url = attachments[0].preview_url;
        if (preview_url) {
          this.preview_url = preview_url;
        } else {
          let { preview } = await Api.resume.generatePreview({
            attachment_id: attachments[0].id
          });
          if(preview.file_url) {
            this.preview_url = preview.file_url ? preview.file_url : '';
            this.previewEmpty = false;
          } else {
            this.previewEmpty = true;
          }
        }
      } else {
        this.previewEmpty = true;
        // this.$message.info("暂无预览");
      }
    },
    async showTagsModal() {
      console.log(this.jobDetail);
      const first_category_id = this.jobDetail.first_category_id;
      const second_category_id = this.jobDetail.second_category_id;
      const third_category_id = this.jobDetail.third_category_id;
      let id = third_category_id == 0 ? second_category_id == 0 ? first_category_id : second_category_id : third_category_id;
      if(id) {
        let { skills } = await Api.common.getSkills({ function_id: id });
        skills.forEach( item => { item.is_default = '0' });
        console.log(skills);
        this.skillsTag = skills;
        if(skills.length != 0) {
          this.$refs.tagsModal.show(skills);
        } else {
          this.$message.info('该职能类型下没有技能标签');
        }
      } else {
        this.$message.info('请先选择职能！');
      }

    },
    updateSkills(skills) {
      // 处理skills选中的项目
      console.log(skills);
      let selectSkills = [];
      let str = '';
      selectSkills = selectSkills.concat(skills.filter( skill => ((skill.is_default === '1'))));
      selectSkills.forEach( item => {
        str += item.skill_name + ',';
      })
      str = str.slice(0, str.length -1);
      this.form.setFieldsValue({ 'requirement_skill': str });
    }
  }
};
</script>

<style lang="scss">
.cloud {
  .show {
    display: inline-block;
  }
  .hide {
    display: none;
  }
  padding-bottom: 45px;
  .search-bar {
    margin-top: 25px;
    background: #fff;
    height: 46px;

    .ant-btn {
      line-height: 46px;
      height: 46px;
    }
    .search-box {
      .ant-input {
        line-height: 46px;
        height: 46px;
      }
      .ant-btn {
        width: 100px;
      }
    }
  }
  .data-list {
    // min-height: 400px;
    padding: 15px 0 35px;
    li {
      margin-top: 11px;
      padding: 20px 20px 5px 20px;
      border-radius: 3px;
      border: 1px solid rgba(228, 232, 235, 1);
      &:hover {
        background: #f5f7fa;
      }
      .row {
        margin-bottom: 10px;
        .col {
          display: flex;
          align-items: center;
          &.gap {
            span:not(:last-child) {
              margin-right: 16px;
            }
          }
          span {
            display: flex;
            align-items: center;
            &.name {
              font-size: 16px;
              font-weight: bold;
            }
            &.match {
              font-size: 16px;
              color: #fc5646;
              font-weight: bold;
            }
            &.hc {
              background: #f6b502;
              padding: 0 3px;
              font-size: 12px;
              border-radius: 2px;
              height: 18px;
              color: #fff;
            }
            &.time {
              color: #999;
              .anticon {
                margin-right: 5px;
                font-size: 16px;
              }
            }
            &.salary {
              font-size: 16px;
              color: #fc5646;
            }
            .anticon {
              font-size: 18px;
              margin-right: 5px;
            }
          }
          a {
            display: inline-block;
            margin-left: 20px;
            .anticon {
              margin-right: 5px;
            }
          }
          .ant-btn {
            margin-left: 20px;
          }
        }
      }
      .ant-divider-horizontal {
        margin: 18px 0;
      }
    }
  }
  .textLeft {
    text-align: left;
    .resumeName {
      font-size: 18px;
      font-weight: bold;
    }
    .result {
      font-size: 18px;
      color: red;
      font-weight: bold;
    }
  }
  .seeword {
    font-size: 16px;
    color: #35b5fe;
    text-decoration: underline;
    font-weight: bold;
    margin-bottom: 2px;
  }
  .cancel {
    display: inline-block;
    width: 80px;
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    color: #ffffff;
    text-align: center;
    background: #999999;
    margin-right: 5px;
    pointer-events: none;
  }
  .confirm {
    display: inline-block;
    width: 80px;
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    color: #ffffff;
    text-align: center;
    background: #35b5fe;
    margin-right: 5px;
  }
  .draw-form {
    // display: flex;
    // flex-wrap: wrap;
    // align-items: center;
    // justify-content: space-between;
    margin-bottom: 20px;
    .form-item {
      margin-right: 40px;
      margin-bottom: 10px;
    }
  }
  ::v-deep .ant-form-inline .ant-form-item > .ant-form-item-control-wrapper, .ant-form-inline .ant-form-item > .ant-form-item-label {
    vertical-align: middle;
  }
}
.drawer-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60px;
  background: rgba(0,0,0,0.23);
  position:absolute;
  bottom: 0;
  left: 0;
}
</style>
